import { render, staticRenderFns } from "./UpcomingAppointmentAlert.vue?vue&type=template&id=691da8ba&scoped=true"
import script from "./UpcomingAppointmentAlert.vue?vue&type=script&lang=js"
export * from "./UpcomingAppointmentAlert.vue?vue&type=script&lang=js"
import style0 from "./UpcomingAppointmentAlert.vue?vue&type=style&index=0&id=691da8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691da8ba",
  null
  
)

export default component.exports